import { useClientInfo } from "frontend/subscriptions";
import { getUnixTimestampUTC } from "shared/util/utils";
import style from "./active-board-user.module.css";
import consts from "shared/consts";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";
import { SyncService } from "frontend/services/syncService";
import { useAtomValue } from "jotai";
import { userAtom } from "state-atoms/users-atoms";
import cn from "classnames";

export default function ActiveBoardUser({
  syncService,
  clientID,
  isFollowing = false,
  onSelected,
  variant = "default",
}: {
  syncService: SyncService<RW> | null;
  clientID: string;
  isFollowing?: boolean;
  onSelected?: () => void;
  variant?: "default" | "cim";
}) {
  const info = useClientInfo(syncService?.getReplicache(), clientID);
  const currentUser = useAtomValue(userAtom);
  const userInfo = info?.userInfo;

  function renderFollowing() {
    if (!isFollowing || !info) {
      return null;
    }
    return <FollowingIcon color={info.userInfo.color} />;
  }

  if (!userInfo || (currentUser && userInfo.id === currentUser?.id)) {
    return null;
  }

  const idle =
    variant === "default" && info.lastUpdated < getUnixTimestampUTC() - consts.IDLE_USER_THRESHOLD_IN_SEC * 1000;

  return (
    <div
      className={cn(style.container, variant === "cim" && style.cim)}
      style={{ backgroundColor: info.userInfo.color, opacity: idle ? 0.5 : 1 }}
      title={userInfo.name}
      onClick={onSelected}
    >
      <div className={style.bg} style={{ backgroundColor: !userInfo.photoURL ? info.userInfo.color : undefined }} />
      {userInfo.photoURL && <img src={userInfo.photoURL} />}
      {userInfo.avatar && <span>{userInfo.avatar}</span>}
      {renderFollowing()}
    </div>
  );
}

function FollowingIcon({ color }: { color: string }) {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={style.followingIcon}
    >
      <path
        d="M10.5 1.5C3.71429 1.5 1 8 1 8C1 8 3.71429 14.5 10.5 14.5C17.2857 14.5 20 8 20 8C20 8 17.2857 1.5 10.5 1.5Z"
        fill="white"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M10.5 3.51471C5.51051 3.51471 3.51471 8.00526 3.51471 8.00526C3.51471 8.00526 5.51051 12.4958 10.5 12.4958C15.4895 12.4958 17.4853 8.00526 17.4853 8.00526C17.4853 8.00526 15.4895 3.51471 10.5 3.51471Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.5 10.5C11.8778 10.5 12.9948 9.38309 12.9948 8.00528C12.9948 6.62747 11.8778 5.51053 10.5 5.51053C9.12222 5.51053 8.00528 6.62747 8.00528 8.00528C8.00528 9.38309 9.12222 10.5 10.5 10.5Z"
        fill={color}
        stroke={color}
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
